module.exports = __webpack_public_path__ + "img/sync-basalam.33f4b693.png";